<script lang="ts" setup>
import { IonModal } from '@ionic/vue'
import { ref } from 'vue'
import type { Chat } from '@/types'
import { bgUrl } from '@/mocks/mock'
import AutoClickButton from '@/components/AutoClickButton.vue'
import ShareButton from '@/components/ShareButton.vue'
import FavouriteButton from '@/components/FavouriteButton.vue'

interface Props {
  chat: Chat
  nextChat: Chat | undefined
  isOpen: boolean
}

interface Emits {
  (e: 'close'): void
  (e: 'next'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const modal = ref()
const shareButtonRef = ref<InstanceType<typeof ShareButton> | null>(null)
function handleGoNext() {
  shareButtonRef.value?.dismissSheet()
  emit('next')
}
</script>

<template>
  <ion-modal
    id="ending-modal"
    ref="modal"
    :is-open="isOpen"
    class="px-24"
    style="--backdrop-opacity: 0.5"
    :can-dismiss="false"
  >
    <div class="wrapper relative">
      <h1 class="text-4.5 font-bold line-height-relaxed text-center">
        Discover Next Sekai
      </h1>
      <div class="mx-auto mt-9 w-70%">
        <img
          class="rd-4"
          :src="props.nextChat?.universe.events[0].gifUrl || bgUrl"
        >
        <p class="name text-2.5 text-start line-clamp-1 text-ellipsis pb-2">
          {{ props.nextChat?.universe.creatorName }}
        </p>
        <div class="pt-4 flex justify-between items-center">
          <div class="flex items-center cursor-pointer" @click="handleGoNext">
            <auto-click-button :duration="5" @on-go-next="handleGoNext" />
            <span class="next-text pl-2 text-3 font-bold">Play Next</span>
          </div>
        </div>
        <div class="flex justify-between mt-12">
          <div class="flex flex-col gap-2 items-center">
            <div class="bg-btn rd-full p-2 h-11">
              <favourite-button
                :chat="chat"
                :is-favorite="chat?.isStared || false"
              />
            </div>
            <p class="text-3">
              Favorite
            </p>
          </div>
          <div
            class="flex flex-col gap-2 items-center"
          >
            <div class="bg-btn rd-full p-2 h-11">
              <share-button
                ref="shareButtonRef"
                :chat="chat"
              />
            </div>
            <p class="text-3">
              Share
            </p>
          </div>
        </div>
      </div>
    </div>
  </ion-modal>
</template>

<style scoped>
ion-modal {
  background: rgba(0, 0, 0, 0.72);
}

.tags {
  color: var(--white-trans-white-72, rgba(255, 255, 255, 0.72));
}
.name {
  color: var(--dark-gray-tertiary-text, #8f8f8f);
}

.next-text {
  color: var(--dark-gray-secondary-text, #bdbdbd);
}

ion-modal#ending-modal {
  --width: fit-content;
  --min-width: 250px;
  --height: fit-content;
  --border-radius: 6px;
  --background: transparent;
}

ion-modal#ending-modal .wrapper {
  margin-bottom: 10px;
}

.bg-btn {
  background: rgba(0, 0, 0, 0.24);
}
</style>
